var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticClass:"w-100 my-auto",attrs:{"id":"salesParticipation"}}),_c('CElementCover',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }